import React from 'react'
import { Field, ErrorMessage } from 'formik'
import TextError from './TextError'

function checkboxHorizantal(props) {
    const { label, name, options, ...rest } = props
    return (
        <div className="row ">
            {/* <label >{label}</label> */}
            <Field name={name} {...rest} >
                {
                    ({ field }) => {
                        return options.map(option => {
                            return (
                                <React.Fragment key={option.key} >
                                    {/* <div className="col-sm-1 col-lg-1" /> */}
                                    <div className="col-sm-4" >
                                        <div>
                                            <div class="form-check form-check-inline">

                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    // id="inlineCheckbox1"
                                                    id={option.value}
                                                    {...field}
                                                    {...rest}
                                                    value={option.value}
                                                    checked={field.value.includes(option.value)}
                                                />
                                                <label class="form-check-label" htmlFor={option.value}>{option.key}</label>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )
                        })
                    }
                }
            </Field>
            <ErrorMessage name={name} component={TextError} />
        </div>
    )
}

export default checkboxHorizantal
